import ToothElevenSelected from '../../assets/teeth/11-21.s.png';
import ToothElevenOver from '../../assets/teeth/11-21.o.png';
import ToothElevenWhite from '../../assets/teeth/11-21.w.png';
import ToothTwelveSelected from '../../assets/teeth/12-22.s.png';
import ToothTwelveOver from '../../assets/teeth/12-22.o.png';
import ToothTwelveWhite from '../../assets/teeth/12-22.w.png';
import ToothThirteenSelected from '../../assets/teeth/13-23.s.png';
import ToothThirteenOver from '../../assets/teeth/13-23.o.png';
import ToothThirteenWhite from '../../assets/teeth/13-23.w.png';
import ToothFourteenSelected from '../../assets/teeth/14-24.s.png';
import ToothFourteenOver from '../../assets/teeth/14-24.o.png';
import ToothFourteenWhite from '../../assets/teeth/14-24.w.png';
import ToothFifteenSelected from '../../assets/teeth/15-25.s.png';
import ToothFifteenOver from '../../assets/teeth/15-25.o.png';
import ToothFifteenWhite from '../../assets/teeth/15-25.w.png';
import ToothSixteenSelected from '../../assets/teeth/16-26.s.png';
import ToothSixteenOver from '../../assets/teeth/16-26.o.png';
import ToothSixteenWhite from '../../assets/teeth/16-26.w.png';
import ToothSeventeenSelected from '../../assets/teeth/17-27.s.png';
import ToothSeventeenOver from '../../assets/teeth/17-27.o.png';
import ToothSeventeenWhite from '../../assets/teeth/17-27.w.png';
import ToothEighteenSelected from '../../assets/teeth/18-28.s.png';
import ToothEighteenOver from '../../assets/teeth/18-28.o.png';
import ToothEighteenWhite from '../../assets/teeth/18-28.w.png';
import ToothThirtyOneSelected from '../../assets/teeth/31-41.s.png';
import ToothThirtyOneOver from '../../assets/teeth/31-41.o.png';
import ToothThirtyOneWhite from '../../assets/teeth/31-41.w.png';
import ToothThirtyTwoSelected from '../../assets/teeth/32-42.s.png';
import ToothThirtyTwoOver from '../../assets/teeth/32-42.o.png';
import ToothThirtyTwoWhite from '../../assets/teeth/32-42.w.png';
import ToothThirtyThreeSelected from '../../assets/teeth/33-43.s.png';
import ToothThirtyThreeOver from '../../assets/teeth/33-43.o.png';
import ToothThirtyThreeWhite from '../../assets/teeth/33-43.w.png';
import ToothThirtyFourSelected from '../../assets/teeth/34-44.s.png';
import ToothThirtyFourOver from '../../assets/teeth/34-44.o.png';
import ToothThirtyFourWhite from '../../assets/teeth/34-44.w.png';
import ToothThirtyFiveSelected from '../../assets/teeth/35-45.s.png';
import ToothThirtyFiveOver from '../../assets/teeth/35-45.o.png';
import ToothThirtyFiveWhite from '../../assets/teeth/35-45.w.png';
import ToothThirtySixSelected from '../../assets/teeth/36-46.s.png';
import ToothThirtySixOver from '../../assets/teeth/36-46.o.png';
import ToothThirtySixWhite from '../../assets/teeth/36-46.w.png';
import ToothThirtySevenSelected from '../../assets/teeth/37-47.s.png';
import ToothThirtySevenOver from '../../assets/teeth/37-47.o.png';
import ToothThirtySevenWhite from '../../assets/teeth/37-47.w.png';
import ToothThirtyEightSelected from '../../assets/teeth/38-48.s.png';
import ToothThirtyEightOver from '../../assets/teeth/38-48.o.png';
import ToothThirtyEightWhite from '../../assets/teeth/38-48.w.png';
import ToothFiftyOneSelected from '../../assets/teeth/51-61.s.png';
import ToothFiftyOneOver from '../../assets/teeth/51-61.o.png';
import ToothFiftyOneWhite from '../../assets/teeth/51-61.w.png';
import ToothFiftyTwoSelected from '../../assets/teeth/52-62.s.png';
import ToothFiftyTwoOver from '../../assets/teeth/52-62.o.png';
import ToothFiftyTwoWhite from '../../assets/teeth/52-62.w.png';
import ToothFiftyThreeSelected from '../../assets/teeth/53-63.s.png';
import ToothFiftyThreeOver from '../../assets/teeth/53-63.o.png';
import ToothFiftyThreeWhite from '../../assets/teeth/53-63.w.png';
import ToothFiftyFourSelected from '../../assets/teeth/54-64.s.png';
import ToothFiftyFourOver from '../../assets/teeth/54-64.o.png';
import ToothFiftyFourWhite from '../../assets/teeth/54-64.w.png';
import ToothFiftyFiveSelected from '../../assets/teeth/55-65.s.png';
import ToothFiftyFiveOver from '../../assets/teeth/55-65.o.png';
import ToothFiftyFiveWhite from '../../assets/teeth/55-65.w.png';
import ToothSeventyOneSelected from '../../assets/teeth/71-81.s.png';
import ToothSeventyOneOver from '../../assets/teeth/71-81.o.png';
import ToothSeventyOneWhite from '../../assets/teeth/71-81.w.png';
import ToothSeventyTwoSelected from '../../assets/teeth/72-82.s.png';
import ToothSeventyTwoOver from '../../assets/teeth/72-82.o.png';
import ToothSeventyTwoWhite from '../../assets/teeth/72-82.w.png';
import ToothSeventyThreeSelected from '../../assets/teeth/73-83.s.png';
import ToothSeventyThreeOver from '../../assets/teeth/73-83.o.png';
import ToothSeventyThreeWhite from '../../assets/teeth/73-83.w.png';
import ToothSeventyFourSelected from '../../assets/teeth/74-84.s.png';
import ToothSeventyFourOver from '../../assets/teeth/74-84.o.png';
import ToothSeventyFourWhite from '../../assets/teeth/74-84.w.png';
import ToothSeventyFiveSelected from '../../assets/teeth/75-85.s.png';
import ToothSeventyFiveOver from '../../assets/teeth/75-85.o.png';
import ToothSeventyFiveWhite from '../../assets/teeth/75-85.w.png';

const TeethImagesConfig = [
  undefined, // 0
  undefined, // 1
  undefined, // 2
  undefined, // 3
  undefined, // 4
  undefined, // 5
  undefined, // 6
  undefined, // 7
  undefined, // 8
  undefined, // 9
  undefined, // 10
  { // 11
    toothWhite: ToothElevenWhite,
    toothSelected: ToothElevenSelected,
    toothOver: ToothElevenOver,
    flipped: false,
    FDI: '1.1',
    ADA: '8',
  },
  { // 12
    toothWhite: ToothTwelveWhite,
    toothSelected: ToothTwelveSelected,
    toothOver: ToothTwelveOver,
    flipped: false,
    FDI: '1.2',
    ADA: '7',
  },
  { // 13
    toothWhite: ToothThirteenWhite,
    toothSelected: ToothThirteenSelected,
    toothOver: ToothThirteenOver,
    flipped: false,
    FDI: '1.3',
    ADA: '6',
  },
  { // 14
    toothWhite: ToothFourteenWhite,
    toothSelected: ToothFourteenSelected,
    toothOver: ToothFourteenOver,
    flipped: false,
    FDI: '1.4',
    ADA: '5',
  },
  { // 15
    toothWhite: ToothFifteenWhite,
    toothSelected: ToothFifteenSelected,
    toothOver: ToothFifteenOver,
    flipped: false,
    FDI: '1.5',
    ADA: '4',
  },
  { // 16
    toothWhite: ToothSixteenWhite,
    toothSelected: ToothSixteenSelected,
    toothOver: ToothSixteenOver,
    flipped: false,
    FDI: '1.6',
    ADA: '3',
  },
  { // 17
    toothWhite: ToothSeventeenWhite,
    toothSelected: ToothSeventeenSelected,
    toothOver: ToothSeventeenOver,
    flipped: false,
    FDI: '1.7',
    ADA: '2',
  },
  { // 18
    toothWhite: ToothEighteenWhite,
    toothSelected: ToothEighteenSelected,
    toothOver: ToothEighteenOver,
    flipped: false,
    FDI: '1.8',
    ADA: '1',
  },
  undefined, // 19
  undefined, // 20
  { // 21
    toothWhite: ToothElevenWhite,
    toothSelected: ToothElevenSelected,
    toothOver: ToothElevenOver,
    flipped: true,
    FDI: '2.1',
    ADA: '9',
  },
  { // 22
    toothWhite: ToothTwelveWhite,
    toothSelected: ToothTwelveSelected,
    toothOver: ToothTwelveOver,
    flipped: true,
    FDI: '2.2',
    ADA: '10',
  },
  { // 23
    toothWhite: ToothThirteenWhite,
    toothSelected: ToothThirteenSelected,
    toothOver: ToothThirteenOver,
    flipped: true,
    FDI: '2.3',
    ADA: '11',
  },
  { // 24
    toothWhite: ToothFourteenWhite,
    toothSelected: ToothFourteenSelected,
    toothOver: ToothFourteenOver,
    flipped: true,
    FDI: '2.4',
    ADA: '12',
  },
  { // 25
    toothWhite: ToothFifteenWhite,
    toothSelected: ToothFifteenSelected,
    toothOver: ToothFifteenOver,
    flipped: true,
    FDI: '2.5',
    ADA: '13',
  },
  { // 26
    toothWhite: ToothSixteenWhite,
    toothSelected: ToothSixteenSelected,
    toothOver: ToothSixteenOver,
    flipped: true,
    FDI: '2.6',
    ADA: '14',
  },
  { // 27
    toothWhite: ToothSeventeenWhite,
    toothSelected: ToothSeventeenSelected,
    toothOver: ToothSeventeenOver,
    flipped: true,
    FDI: '2.7',
    ADA: '15',
  },
  { // 28
    toothWhite: ToothEighteenWhite,
    toothSelected: ToothEighteenSelected,
    toothOver: ToothEighteenOver,
    flipped: true,
    FDI: '2.8',
    ADA: '16',
  },
  undefined, // 29
  undefined, // 30
  { // 31
    toothWhite: ToothThirtyOneWhite,
    toothSelected: ToothThirtyOneSelected,
    toothOver: ToothThirtyOneOver,
    flipped: false,
    FDI: '4.1',
    ADA: '24',
  },
  { // 32
    toothWhite: ToothThirtyTwoWhite,
    toothSelected: ToothThirtyTwoSelected,
    toothOver: ToothThirtyTwoOver,
    flipped: false,
    FDI: '4.2',
    ADA: '23',
  },
  { // 33
    toothWhite: ToothThirtyThreeWhite,
    toothSelected: ToothThirtyThreeSelected,
    toothOver: ToothThirtyThreeOver,
    flipped: false,
    FDI: '4.3',
    ADA: '22',
  },
  { // 34
    toothWhite: ToothThirtyFourWhite,
    toothSelected: ToothThirtyFourSelected,
    toothOver: ToothThirtyFourOver,
    flipped: false,
    FDI: '4.4',
    ADA: '21',
  },
  { // 35
    toothWhite: ToothThirtyFiveWhite,
    toothSelected: ToothThirtyFiveSelected,
    toothOver: ToothThirtyFiveOver,
    flipped: false,
    FDI: '4.5',
    ADA: '20',
  },
  { // 36
    toothWhite: ToothThirtySixWhite,
    toothSelected: ToothThirtySixSelected,
    toothOver: ToothThirtySixOver,
    flipped: false,
    FDI: '4.6',
    ADA: '19',
  },
  { // 37
    toothWhite: ToothThirtySevenWhite,
    toothSelected: ToothThirtySevenSelected,
    toothOver: ToothThirtySevenOver,
    flipped: false,
    FDI: '4.7',
    ADA: '18',
  },
  { // 38
    toothWhite: ToothThirtyEightWhite,
    toothSelected: ToothThirtyEightSelected,
    toothOver: ToothThirtyEightOver,
    flipped: false,
    FDI: '4.8',
    ADA: '17',
  },
  undefined, // 39
  undefined, // 40
  { // 41
    toothWhite: ToothThirtyOneWhite,
    toothSelected: ToothThirtyOneSelected,
    toothOver: ToothThirtyOneOver,
    flipped: true,
    FDI: '3.1',
    ADA: '25',
  },
  { // 42
    toothWhite: ToothThirtyTwoWhite,
    toothSelected: ToothThirtyTwoSelected,
    toothOver: ToothThirtyTwoOver,
    flipped: true,
    FDI: '3.2',
    ADA: '26',
  },
  { // 43
    toothWhite: ToothThirtyThreeWhite,
    toothSelected: ToothThirtyThreeSelected,
    toothOver: ToothThirtyThreeOver,
    flipped: true,
    FDI: '3.3',
    ADA: '27',
  },
  { // 44
    toothWhite: ToothThirtyFourWhite,
    toothSelected: ToothThirtyFourSelected,
    toothOver: ToothThirtyFourOver,
    flipped: true,
    FDI: '3.4',
    ADA: '28',
  },
  { // 45
    toothWhite: ToothThirtyFiveWhite,
    toothSelected: ToothThirtyFiveSelected,
    toothOver: ToothThirtyFiveOver,
    flipped: true,
    FDI: '3.5',
    ADA: '29',
  },
  { // 46
    toothWhite: ToothThirtySixWhite,
    toothSelected: ToothThirtySixSelected,
    toothOver: ToothThirtySixOver,
    flipped: true,
    FDI: '3.6',
    ADA: '30',
  },
  { // 47
    toothWhite: ToothThirtySevenWhite,
    toothSelected: ToothThirtySevenSelected,
    toothOver: ToothThirtySevenOver,
    flipped: true,
    FDI: '3.7',
    ADA: '31',
  },
  { // 48
    toothWhite: ToothThirtyEightWhite,
    toothSelected: ToothThirtyEightSelected,
    toothOver: ToothThirtyEightOver,
    flipped: true,
    FDI: '3.8',
    ADA: '32',
  },
  undefined, // 49
  undefined, // 50
  {
    toothWhite: ToothFiftyOneWhite,
    toothSelected: ToothFiftyOneSelected,
    toothOver: ToothFiftyOneOver,
    flipped: false,
    FDI: '5.1',
    ADA: 'E',
  },
  {
    toothWhite: ToothFiftyTwoWhite,
    toothSelected: ToothFiftyTwoSelected,
    toothOver: ToothFiftyTwoOver,
    flipped: false,
    FDI: '5.2',
    ADA: 'D',
  },
  {
    toothWhite: ToothFiftyThreeWhite,
    toothSelected: ToothFiftyThreeSelected,
    toothOver: ToothFiftyThreeOver,
    flipped: false,
    FDI: '5.3',
    ADA: 'C',
  },
  {
    toothWhite: ToothFiftyFourWhite,
    toothSelected: ToothFiftyFourSelected,
    toothOver: ToothFiftyFourOver,
    flipped: false,
    FDI: '5.4',
    ADA: 'B',
  },
  {
    toothWhite: ToothFiftyFiveWhite,
    toothSelected: ToothFiftyFiveSelected,
    toothOver: ToothFiftyFiveOver,
    flipped: false,
    FDI: '5.5',
    ADA: 'A',
  },
  undefined, // 56
  undefined, // 57
  undefined, // 58
  undefined, // 59
  undefined, // 60
  {
    toothWhite: ToothFiftyOneWhite,
    toothSelected: ToothFiftyOneSelected,
    toothOver: ToothFiftyOneOver,
    flipped: true,
    FDI: '6.1',
    ADA: 'F',
  },
  {
    toothWhite: ToothFiftyTwoWhite,
    toothSelected: ToothFiftyTwoSelected,
    toothOver: ToothFiftyTwoOver,
    flipped: true,
    FDI: '6.2',
    ADA: 'G',
  },
  {
    toothWhite: ToothFiftyThreeWhite,
    toothSelected: ToothFiftyThreeSelected,
    toothOver: ToothFiftyThreeOver,
    flipped: true,
    FDI: '6.3',
    ADA: 'H',
  },
  {
    toothWhite: ToothFiftyFourWhite,
    toothSelected: ToothFiftyFourSelected,
    toothOver: ToothFiftyFourOver,
    flipped: true,
    FDI: '6.4',
    ADA: 'I',
  },
  {
    toothWhite: ToothFiftyFiveWhite,
    toothSelected: ToothFiftyFiveSelected,
    toothOver: ToothFiftyFiveOver,
    flipped: true,
    FDI: '6.5',
    ADA: 'J',
  },
  undefined, // 66
  undefined, // 67
  undefined, // 68
  undefined, // 69
  undefined, // 70
  {
    toothWhite: ToothSeventyOneWhite,
    toothSelected: ToothSeventyOneSelected,
    toothOver: ToothSeventyOneOver,
    flipped: true,
    FDI: '7.1',
    ADA: 'O',
  },
  {
    toothWhite: ToothSeventyTwoWhite,
    toothSelected: ToothSeventyTwoSelected,
    toothOver: ToothSeventyTwoOver,
    flipped: true,
    FDI: '7.2',
    ADA: 'N',
  },
  {
    toothWhite: ToothSeventyThreeWhite,
    toothSelected: ToothSeventyThreeSelected,
    toothOver: ToothSeventyThreeOver,
    flipped: true,
    FDI: '7.3',
    ADA: 'M',
  },
  {
    toothWhite: ToothSeventyFourWhite,
    toothSelected: ToothSeventyFourSelected,
    toothOver: ToothSeventyFourOver,
    flipped: true,
    FDI: '7.4',
    ADA: 'L',
  },
  {
    toothWhite: ToothSeventyFiveWhite,
    toothSelected: ToothSeventyFiveSelected,
    toothOver: ToothSeventyFiveOver,
    flipped: true,
    FDI: '7.5',
    ADA: 'K',
  },
  undefined, // 76
  undefined, // 77
  undefined, // 78
  undefined, // 79
  undefined, // 80
  {
    toothWhite: ToothSeventyOneWhite,
    toothSelected: ToothSeventyOneSelected,
    toothOver: ToothSeventyOneOver,
    flipped: false,
    FDI: '8.1',
    ADA: 'P',
  },
  {
    toothWhite: ToothSeventyTwoWhite,
    toothSelected: ToothSeventyTwoSelected,
    toothOver: ToothSeventyTwoOver,
    flipped: false,
    FDI: '8.2',
    ADA: 'Q',
  },
  {
    toothWhite: ToothSeventyThreeWhite,
    toothSelected: ToothSeventyThreeSelected,
    toothOver: ToothSeventyThreeOver,
    flipped: false,
    FDI: '8.3',
    ADA: 'R',
  },
  {
    toothWhite: ToothSeventyFourWhite,
    toothSelected: ToothSeventyFourSelected,
    toothOver: ToothSeventyFourOver,
    flipped: false,
    FDI: '8.4',
    ADA: 'S',
  },
  {
    toothWhite: ToothSeventyFiveWhite,
    toothSelected: ToothSeventyFiveSelected,
    toothOver: ToothSeventyFiveOver,
    flipped: false,
    FDI: '8.5',
    ADA: 'T',
  }
];

export default TeethImagesConfig;
